import { useState } from 'react';
import { SelectionConfig } from '../types';
import './SelectionMenu.css';

interface SelectionMenuProps {
  onConfirm: (config: SelectionConfig) => void;
}

type CharacterKey = 'Man' | 'Woman';
type AccentKey = 'American' | 'British' | 'Australian';

const VOICE_DICTIONARY: Record<string, { voice: string; language: string }> = {
  'Man-American': { voice: 'en-US-Neural2-J', language: 'en-US' },
  'Man-British': { voice: 'en-GB-Wavenet-B', language: 'en-GB' },
  'Man-Australian': { voice: 'en-AU-Wavenet-D', language: 'en-AU' },
  'Woman-American': { voice: 'en-US-Journey-O', language: 'en-US' },
  'Woman-British': { voice: 'en-GB-Wavenet-A', language: 'en-GB' },
  'Woman-Australian': { voice: 'en-AU-News-E', language: 'en-AU' },
};

const PDF_URL = 'https://mentoraibot.s3.us-east-1.amazonaws.com/Manual+NIAN.pdf';

export function SelectionMenu({ onConfirm }: SelectionMenuProps) {
  const [selectedCharacter, setSelectedCharacter] = useState<CharacterKey>('Man');
  const [selectedAccent, setSelectedAccent] = useState<AccentKey>('American');
  const [isDownloading, setIsDownloading] = useState(false);

  const resolveBotName = (character: CharacterKey) => {
    return character === 'Woman' ? 'Nia' : 'Ian';
  };

  const handleDownloadPdf = () => {
    setIsDownloading(true);
    window.open(PDF_URL, '_blank', 'noopener,noreferrer');
    setTimeout(() => setIsDownloading(false), 400);
  };

  const handleConfirm = () => {
    const key = `${selectedCharacter}-${selectedAccent}`;
    const voiceInfo = VOICE_DICTIONARY[key] || VOICE_DICTIONARY['Man-American'];
    onConfirm({
      character: resolveBotName(selectedCharacter),
      accent: selectedAccent,
      voice: voiceInfo.voice,
      language: voiceInfo.language,
    });
  };

  return (
    <div className="selection-menu">
      <div className="selection-menu-content">
        <header className="selection-header">
          <h1>Hello, I'm Nian!</h1>
          <p>*Choose the coach and the accent that best suit your style.</p>
        </header>

        <div className="character-grid">
          <button
            className={`character-card ian-card ${selectedCharacter === 'Man' ? 'selected' : ''}`}
            onClick={() => setSelectedCharacter('Man')}
          >
            <span className="character-name">IAN</span>
            {selectedCharacter === 'Man' && (
              <img
                src="/assets/selection/check.png"
                alt=""
                aria-hidden="true"
                className="character-check"
              />
            )}
            <div className="character-body">
              <div className="character-image-wrapper">
                <img src="/assets/selection/ian.png" alt="Ian" className="character-image" />
              </div>
            </div>
          </button>

          <button
            className={`character-card nia-card ${selectedCharacter === 'Woman' ? 'selected' : ''}`}
            onClick={() => setSelectedCharacter('Woman')}
          >
            <span className="character-name">NIA</span>
            {selectedCharacter === 'Woman' && (
              <img
                src="/assets/selection/check.png"
                alt=""
                aria-hidden="true"
                className="character-check"
              />
            )}
            <div className="character-body">
              <div className="character-image-wrapper">
                <img src="/assets/selection/nia.png" alt="Nia" className="character-image" />
              </div>
            </div>
          </button>
        </div>

        <div className="accent-row">
          <button
            className={`accent-button ${selectedAccent === 'American' ? 'selected' : ''}`}
            onClick={() => setSelectedAccent('American')}
          >
            <img src="/assets/selection/american.png" alt="American" />
            <span>American</span>
          </button>
          <button
            className={`accent-button ${selectedAccent === 'British' ? 'selected' : ''}`}
            onClick={() => setSelectedAccent('British')}
          >
            <img src="/assets/selection/British.png" alt="British" />
            <span>British</span>
          </button>
          <button
            className={`accent-button ${selectedAccent === 'Australian' ? 'selected' : ''}`}
            onClick={() => setSelectedAccent('Australian')}
          >
            <img src="/assets/selection/Australian.png" alt="Australian" />
            <span>Australian</span>
          </button>
        </div>

        <button
          className="download-link"
          onClick={handleDownloadPdf}
          disabled={isDownloading}
        >
          <img src="/assets/selection/download.png" alt="" aria-hidden="true" />
          <span>{isDownloading ? 'Descargando...' : 'Descargar guía para uso de tu Coach'}</span>
        </button>

        <div className="accept-row">
          <button className="primary-button" onClick={handleConfirm} aria-label="Aceptar">
            <img src="/assets/selection/Boton_Aceptar.png" alt="" aria-hidden="true" />
            <span className="primary-button-label">Aceptar</span>
          </button>
        </div>
      </div>
    </div>
  );
}
